//Module Keys
let locales = {};

//Merge Views
import main from 'Modules/events/views/main/lan/en';
import createEditEvent from 'Modules/events/views/.components/createEditEvent/lan/en';
import deleteEvent from 'Modules/events/views/.components/deleteEvent/lan/en';
import unitTypeEvents from 'Modules/events/.components/unitTypeEvents/lan/en';
import createEditUnitTypeEvent from 'Modules/events/.components/createEditUnitTypeEvent/lan/en';
import deleteUnitTypeEvent from 'Modules/events/.components/deleteUnitTypeEvent/lan/en';

locales = {
    ...locales,
    ...main,
    ...createEditEvent,
    ...deleteEvent,
    ...unitTypeEvents,
    ...createEditUnitTypeEvent,
    ...deleteUnitTypeEvent,
};


export default locales;